import {
    SALES_SET,
    SALES_PAGINATION_SET,
    SALES_STATISTIC_SET,
    SALES_LOADING_PAGINATION,
    SALES_LOADED_PAGINATION,
    SALES_STATUS_SET,
    SALES_LOADING,
    SALES_LOADED,
    SALES_CLEAR,
    SALES_FILTER_SET,
} from '../actionTypes';

import { translate } from '@/i18n/src/locales';

const initialState = {
    sales: [],
    salesPagination: {
        VendasFranqueadora: [],
        QtdPaginas: 0
    },
    salesStatistic: {
        TotalPedidos: 0,
        ValorTotalPedidos: 0,
        TotalProdutos: 0,
        TicketMedio: 0
    },
    salesStatus: [],
    salesIsLoading: false,
    filters: [
        { id: 1, description: translate('period'), active: false },
        { id: 2, description: translate('periodDate'), active: true }
    ],
    filterCurrent: { id: 2, description: translate('periodDate'), active: true },
    salesPaginationIsLoading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SALES_SET:
            return {
                ...state,
                sales: action.payload,
            };
        case SALES_PAGINATION_SET:
            return {
                ...state,
                salesPagination: action.payload,
                salesPaginationIsLoading: false,
            };
        case SALES_STATISTIC_SET:
            return {
                ...state,
                salesStatistic: action.payload
            };
        case SALES_LOADING_PAGINATION:
            return {
                ...state,
                salesPaginationIsLoading: true,
                salesPagination: {
                    ...state.salesPagination,
                    VendasFranqueadora: []
                }
            };
        case SALES_LOADED_PAGINATION:
            return {
                ...state,
                salesPaginationIsLoading: false,
            };
        case SALES_STATUS_SET:
            return {
                ...state,
                salesStatus: action.payload,
            };
        case SALES_LOADING:
            return {
                ...state,
                salesIsLoading: true,
            };
        case SALES_LOADED:
            return {
                ...state,
                salesIsLoading: false,
            };
        case SALES_CLEAR:
            return {
                ...state,
                sales: [],
                salesIsLoading: false,
                filters: [
                    { id: 1, description: translate('period'), active: false },
                    { id: 2, description: translate('periodDate'), active: true },
                ],
                filterCurrent: { id: 2, description: translate('periodDate'), active: true },
            };
        case SALES_FILTER_SET:
            return {
                ...state,
                filters: action.payload,
                filterCurrent: action.payload.filter((item) => item.active === true)[0],
            };
        default:
            return state;
    }
};

export default reducer;
